import { render, staticRenderFns } from "./BookingHistory.vue?vue&type=template&id=b345c6c2&scoped=true&"
import script from "./BookingHistory.vue?vue&type=script&lang=js&"
export * from "./BookingHistory.vue?vue&type=script&lang=js&"
import style0 from "./BookingHistory.vue?vue&type=style&index=0&id=b345c6c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b345c6c2",
  null
  
)

export default component.exports